import * as ng from 'angular';
import * as nggt from 'angular-gettext';
import * as uir from '@uirouter/angularjs';

import { SiteConfig } from '../shared';

export class ConfirmationController implements ng.IComponentController {
   static $inject = ['$sce', '$window', '$stateParams', 'config', 'gettextCatalog'];

   constructor(
      private $sce:ng.ISCEService,
      private $window:ng.IWindowService,
      $stateParams:uir.StateParams,
      private config:SiteConfig,
      private gettextCatalog:nggt.gettextCatalog
   ) {
      this.shareUrl = `${$window.location.origin}/${this.language}/`;
      this.qrImageUrl = `//${config.apiDomain}/api/qrSite/image/${$stateParams.wristbandId}`;
   }

   readonly shareUrl:string;
   readonly qrImageUrl:string;

   get language() {
      return this.gettextCatalog.getCurrentLanguage();
   }

   get titleText() {
      return this.config.settings.confirmationTitle[this.language];
   }

   get extraText() {
      let text = this.config.settings.confirmationText[this.language];
      if (text) {
         return this.$sce.trustAsHtml(text);
      }
   }

   get facebookMessage() {
      if (this.config.settings.facebookMessage && this.config.settings.facebookMessage[this.language]) {
         return this.config.settings.facebookMessage[this.language];
      }
   }

   onShareFacebook() {
      let href = encodeURIComponent(this.shareUrl);
      let  url = 'https://www.facebook.com/sharer/sharer.php?u=' + href;
      this.openWindow('Share on Facebook', url);
   }

   get twitterMessage() {
      if (this.config.settings.twitterMessage && this.config.settings.twitterMessage[this.language]) {
         return this.config.settings.twitterMessage[this.language];
      }
   }

   onShareTwitter() {
      let text = this.twitterMessage;

      if (text.indexOf('http') === -1) {
         text = text + ' ' + this.shareUrl;
      }

      let url = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text);
      this.openWindow('Share on Twitter', url);
   }

   private openWindow(title:string, url:string) {
      let w = 550
      let h = 420;

      let wLeft = this.$window.screenLeft ? this.$window.screenLeft : this.$window.screenX;
      let wTop = this.$window.screenTop ? this.$window.screenTop : this.$window.screenY;
      let left = wLeft + (this.$window.innerWidth / 2) - (w / 2);
      let top = wTop + (this.$window.innerHeight / 2) - (h / 2);

      let features = 'toolbar=no,location=no,status=no,menubar=no,resizable=yes';
      features += `,width=${w},height=${h},top=${top},left=${left}`;

      this.$window.open(url, title, features);
   }
}

ng.module('selfReg').component('confirmation', {
   templateUrl: require('./confirmation.html'),
   controller: ConfirmationController
});
